// extracted by mini-css-extract-plugin
export default {"inputStyle":"styles_inputStyle__+uPAk","notice":"styles_notice__KMDnC","lookupContainer":"styles_lookupContainer__M56d5","lookupSelection":"styles_lookupSelection__2sNRs"};